import * as React from 'react';
import { getLogger } from '@olympeio/core';
import { registerDataGridRenderer } from '../../shared/datagrid/DataGridRegistry.jsx';
import { getApplicationContext } from '../../../common/utils/Context';
import BCP from '../../../common/section_bcp/DM_BCP.js';
import { useObjectProperty } from "../../../web/shared/_helpers.js"

//renderer to render the bcp status
registerDataGridRenderer({
    name: 'BCP_STATUS',
    render: (_values, _options, object, $) => {
        return <BCPStatus object={object} $={$} />;
    }
});

/**
 * Render values BCP state
 * @param {!BrickContext} $
 * @param {BCP} object
 */
const BCPStatus = ({ $, object }) => {
    const [bcpStatus, setBcpStatus] = React.useState('');
    const applicationContext = getApplicationContext($);
    //get material, and plant Start
    let plantId = useObjectProperty($, object, BCP.plantIdProp)?.[0]
    let materialId = useObjectProperty($, object, BCP.materialIdProp)?.[0]
    let plantMaterialId = materialId + "-" + plantId
    React.useEffect(() => {
        const status = applicationContext.get('GetBCPRequest_statusMap');
        getLogger('BCPStatusRenderer').info("::: status :::", status)
        const bcp_status = status.get(plantMaterialId)
        getLogger('BCPStatusRenderer').info("::bcp_status::", bcp_status)
        setBcpStatus(bcp_status)
    }, [object]);
    return (
        <span style={{ fontSize: "14px" }}>
            {bcpStatus}
        </span>

    );

};